/**
 * Tab component.
 *
 * @param {object} props
 * @param {Array} props.menus
 *  An array of menu objects to be displayed as tabs.
 * @param {object} props.defaultSelectedTabMenu
 *  The menu object that is selected by default.
 * @param {function} props.onClickTabMenu
 *  Callback function invoked when a tab is clicked, receiving the clicked menu object as an argument.
 */
import { useState } from "react";

export default function Tab({
    menus,
    defaultSelectedTabMenu,
    onClickTabMenu,
}) {
    const [selectedTabMenu, setSelectedTabMenu] = useState(
        defaultSelectedTabMenu
    );

    function handleTabClick(menu) {
        setSelectedTabMenu(menu);
        if (onClickTabMenu) {
            onClickTabMenu(menu);
        }
    }

    function buildTabMenu(menu, index) {
        const isSelected = menu === selectedTabMenu;
        const label = typeof menu === "object" ? menu.label : menu;
        const menuId = typeof menu === "object" ? (menu.id || menu.label || index) : menu;

        return (
            <button
                key={menuId}
                id={menuId}
                role="tab"
                aria-selected={isSelected}
                type="button"
                tabIndex="-1"
                className={`tab-menu ${isSelected ? "selected" : ""} flex flex-col gap-3 items-center`}
                onClick={() => handleTabClick(menu)}
            >
                {label}
                <div className={`tab-indicator ${isSelected ? "selected" : ""}`} />
            </button>
        );
    }
    return (
        <div className="tab" role="tablist" data-tab>
            {menus.map(buildTabMenu)}
        </div>
    );

}